import { render, staticRenderFns } from "./UserLoginView.vue?vue&type=template&id=145ab230&scoped=true&"
import script from "./UserLoginView.vue?vue&type=script&lang=js&"
export * from "./UserLoginView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145ab230",
  null
  
)

export default component.exports